import { trackOpenPanel, identifyOpenPanel, clearOpenPanel } from './openPanelHelper';
import { trackCustomerIo, identifyCustomerIo, clearCustomerIo } from './customerIoHelper';

export const trackEvent = (event, properties = {}) => {
	trackOpenPanel(event, properties);
	trackCustomerIo(event, properties);
};

export const identify = (user, traits = {}) => {
	identifyOpenPanel(user, traits);
	identifyCustomerIo(user, traits);
};

export const identifyAccountVerified = (user, extraTraits = {}) => {
	identify(user, { account_status: 'verified', ...extraTraits });
};

export const clearAnalytics = () => {
	clearOpenPanel();
	clearCustomerIo();
};
